var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"max-width":"500","has-padding":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',[_c('app-login-type-captive-body',{on:{"close":function($event){_vm.show = false}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }